<template>
  <div
    class="text-block py-8 lg:py-16"
    :class="[
      props.model.background,
      props.model.textColor ? props.model.textColor : 'text-[color:var(--color-body-text)]',
    ]"
  >
    <div class="container mx-auto" :class="{ 'lg:pl-[90px]': props.model.tipNumber }">
      <div class="block-content relative" :class="[props.model.textAlignment, props.model.textWidth]">
        <div v-if="props.model.tipNumber" class="pb-4 lg:pb-0 xl:absolute lg:top-[-10px] lg:left-[-80px] lg:block">
          <VcIcon name="veld-icon-bg" :size="60" />

          <span class="tip-number">
            {{ props.model.tipNumber }}
          </span>
        </div>
      </div>
      <component
        class="block-content pb-4 font-bold flex items-center"
        :is="props.model.heading"
        :class="[props.model.textAlignment, props.model.textWidth]"
        v-if="props.model.title"
      >
        {{ props.model.title }}</component
      >

      <div
        v-if="props.model.text"
        class="block-content leading-9 text-lg"
        :class="[props.model.textAlignment, props.model.textWidth]"
        v-html-safe="props.model.text"
      ></div>
      <div class="block-content text-center pt-6" :class="[props.model.textAlignment, props.model.textWidth]">
        <VcButton
          v-if="showTheButton"
          v-bind="getLinkAttr(props.model.buttonUrl)"
          class="w-fit md:w-1/2 px-8 lg:w-auto"
        >
          {{ props.model.buttonLabel }}
        </VcButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { getLinkAttr } from "@/core/utilities/common";

const props = defineProps({
  model: {
    type: Object,
    required: true,
  },
});

const showTheButton = computed(() => {
  return Boolean(props.model.buttonLabel) && Boolean(props.model.buttonUrl);
});
</script>

<style lang="scss">
.text-block {
  .block-content {
    h2 {
      font-size: 50px;
      line-height: 60px;
    }

    .tip-number {
      color: #fff;
      font-weight: bold;
      font-size: 20px;
      position: absolute;
      left: 0;
      top: 0;
      width: 60px;
      height: 60px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    h2,
    h3,
    h4 {
      margin-bottom: 10px;
    }
    p {
      margin-top: 0;
      margin-bottom: 1.25rem;
    }
    &.small {
      max-width: 700px;
      width: 100%;
    }

    &.medium {
      max-width: 900px;
      width: 100%;
    }

    &.large {
      max-width: 1100px;
      width: 100%;
    }

    &.none {
      width: 100%;
    }

    &.left {
      text-align: left;
    }

    &.center {
      margin: 0 auto;
    }

    &.right {
      margin-left: auto;
      margin-right: 0;
    }

    ul {
      list-style: disc inside;
      margin-top: 1.5rem;
    }
  }
}
</style>
